import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

import { CommonDataService } from '../../services/common-data.service';
import { CommerceDataService } from '../../services/commerce-data.service';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-checkout-payment-page',
  templateUrl: './checkout-payment-page.component.html',
  styleUrls: ['./checkout-payment-page.component.css']
})
export class CheckoutPaymentPageComponent implements OnInit {
  
  pageName = "Checkout / Payment Details";
  modelId = '0';
  modelData: any;
  shippingCostValue = 0
  pageReady = false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService,
    private _ecomm: CommerceDataService
  ) {
    $('#loader').show();
   }

  ngOnInit() {
    $('#initialise-page').trigger('click');

    let currentOrder = sessionStorage.getItem('order')
    if(currentOrder && parseInt(currentOrder) > 0) {
      this.modelId = currentOrder
      this.getOrderDetails()
    }

    else {
      //we need to send you back to checkout first page, so we can create an order for you
      let h = {
        class: "iziToast-warning",
        title:  "Order:",
        message:  "We need to capture you billing details first!",
        animateInside: !1,
        position: "topRight",
        progressBar: !1,
        icon: "icon-bell",
        timeout: 3200,
        transitionIn: "fadeInLeft",
        transitionOut: "fadeOut",
        transitionInMobile: "fadeIn",
        transitionOutMobile: "fadeOut",
      };
      iziToast.show(h);

      this.router.navigate(['/shop/checkout/address']);

    }
  }

  getOrderDetails() {
    let queryData = new FormData();
    queryData.append('modelName', 'Order');
    queryData.append('mid', this.modelId);

      $('#loader').show();
      //lets get the model for this page
      this._data.getModelData(queryData) 
      .pipe(first())
      .subscribe(
        data => {
          this.modelData = data['covers'][0]['cover']['model']['modelData']['formFieldsEntities'];
          this.shippingCostValue = parseFloat(this.modelData['shippingInfo']['totalCost'])
          this.pageReady = true;
        },
        error => {

            $('#loader').hide();

        },

        () => {
          $('#loader').hide();
        }
      );
  }

  updateOrderPaymentDetails() {

    $('#buttonText').text('Please Wait...');
    $('#loader').show();

    let paymentMethod = $( "[name=paymentMethod]" ).val();
    let useRewards = $( "#use_points" ).val();
    if(paymentMethod != '') {
      //check the payment method
      let modelObject1 = new FormData();
      modelObject1.append('modelName', 'Order');
      modelObject1.append('id', this.modelId);
      modelObject1.append('paymentDetails-paymentMethod', paymentMethod);
      modelObject1.append('paymentDetails-useRewardPoints', useRewards);

      this.updateModel(modelObject1);
    }

    else {
      iziToast.success({
        title: 'Validation Error!',
        position: 'topRight',
        icon: 'icon-circle-check',
        message: 'Please select a valid payment option.'
    });
    }
  }

  updateModel (modelObject: any) {
    // Initiate new model creation/update method

    this._data.updateModelData(modelObject) 
      .pipe(first())
      .subscribe(
        data => {

        },
        error => {
          console.log(error);

          $('#buttonText').text('Continue ');
          $('#loader').hide();

          iziToast.success({
            title: 'Validation Error!',
            position: 'topRight',
            icon: 'icon-circle-check',
            message: 'Please select a valid payment option and click to continue.'
        });

        },

        () => {
          iziToast.success({
              title: 'Success!',
              position: 'topRight',
              icon: 'icon-circle-check',
              message: 'Your order payment options updated successfuly.'
          });

          $('#buttonText').text('Continue ');
          $('#loader').hide();

          this.router.navigate(['/shop/checkout/review']);
        }
      );
  }

  finaliseOrder() {
    //first getting 
  }



}
